<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Pay by Invoice</div>
				<div class="modal__head__subtitle">Are you sure you want to pay by invoice?</div>
			</div>
			<div class="modal__content">
				<button class="btn primary" @click="emitConfirmSendByInvoice">Confirm Pay by Invoice</button>
			</div>
            
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		props : ['quoteReference'],
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'confirmPayByInvoice',
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods : {
            emitConfirmSendByInvoice(){
                this.$store.commit('openModal', '');
                this.$emit('emitConfirmSendByInvoice');
                
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/confirmPayByInvoice.vue